import React from "react";

import { Check, DoneCheck, Close } from "icons";

import { Tag } from "clearsense-ui/components";

const getStatusColor = text => {
  switch (text) {
    case "Good":
      return "#EBF4EC";
    case "In progress":
      return "#FDF0E3";
    case "Failed":
      return "#FAEAEA";
    default:
      return "";
  }
};

const getStatusIcon = text => {
  if (text === "Failed") {
    return Close;
  }

  return DoneCheck;
};

export const ASSOCIATE_DATA_SOURCE_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
  },
  {
    title: "Database Name",
    key: "db_name",
    dataIndex: "db_name",
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    render: text =>
      text ? (
        <Tag
          label={text}
          color={getStatusColor(text)}
          icon={getStatusIcon(text)}
          className="flex-row-reverse "
        />
      ) : (
        <Tag
          label="Good"
          color={getStatusColor("Good")}
          icon={getStatusIcon("Good")}
          className="flex-row-reverse "
        />
      ),
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];
